import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { RelatorioRequest } from '../../requests/relatorio-interno/relatorio.request';
import { ListaRelatorioResponse } from '../../responses/relatorio-interno/lista-relatorio.response';
import { RelatorioResponse } from '../../responses/relatorio-interno/relatorio.response';

@Injectable({
  providedIn: 'root',
})
export class ConfigurarRelatorioService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }
  public get(titulo: string, perfilAcesso: string, paginaAtual: number): Observable<ListaRelatorioResponse> {
    const uri: string = `configurarrelatorio?titulo=${titulo}&perfilAcesso=${perfilAcesso}&paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaRelatorioResponse>(environment.urlApiRelatorioInterno + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluir(idRelatorio: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(
        environment.urlApiRelatorioInterno + `configurarrelatorio/idRelatorio/${idRelatorio}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public Incluir(criarRelatorioRequest: RelatorioRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiRelatorioInterno + `configurarrelatorio`,
        criarRelatorioRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public Alterar(idRelatorio: number, editarRelatorioRequest: RelatorioRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        environment.urlApiRelatorioInterno + `configurarrelatorio/idRelatorio/${idRelatorio}`,
        editarRelatorioRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public ObterPorId(idRelatorio: number): Observable<RelatorioResponse> {
    return this.httpClient
      .get<RelatorioResponse>(
        environment.urlApiRelatorioInterno + `configurarrelatorio/idRelatorio/${idRelatorio}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
